import React, { useEffect, useState } from 'react';
import styles from './checkout.module.css';
import { Close, Edit } from '../../../Svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCartProductThunk, setCartData } from '../../redux/cartSlice';
import AddBilling from '../../../Dashboard/CustomerDash/Components/addEditAddress/AddBilling';
import { getCustomerProfileThunk, setCustomerEditData } from '../../redux/customerSlice';
import api from '../../utils/api';
import { toast } from 'react-toastify';

const Checkout = () => {

  const navigate = useNavigate()
  const { cartData, loading, refresh } = useSelector((state) => state.cart);
  const [isAddShipPopupOpen, setAddShipPopupOpen] = useState(false);
  const [isEditShipPopupOpen, setEditShipPopupOpen] = useState(false);
  const { customer } = useSelector((state) => state.customer)
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [selectedProducts, setSelectedproducts] = useState([])
  const [checkoutLoading, setCheckoutLoading] = useState(false)
  const [showLess, setShowLess] = useState(true)

  // const displaypro = showLess ? cartData?.s : cartData

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllCartProductThunk());
    dispatch(getCustomerProfileThunk());
  }, [refresh]);

  const handleEditClick = async (data) => {
    await dispatch(setCustomerEditData(data))
    setEditShipPopupOpen(true)
  }

  useEffect(() => {
    if (customer?.shippingAddress?.length > 0) {
      setSelectedAddress(customer.shippingAddress[0]);
    }
  }, [customer]);

  useEffect(() => {
    if (cartData?.length > 0) {
      const selectedProducts = cartData?.map((data) => ({
        productId: data?.productDetails?._id,
        quantity: data?.quantity,
      }));

      setSelectedproducts(selectedProducts)
    }
  }, [cartData])



  const getBreakQtyDetails = (quantityTable, quantity) => {
    if (!quantityTable || !Array.isArray(quantityTable) || quantityTable.length === 0) {
      return { breakQty: 0, unitPrice: 0, finalPrice: 0 };
    }
    const sortedTable = [...quantityTable].sort((a, b) => (a?.breakQty || 0) - (b?.breakQty || 0));
    return sortedTable.find((entry) => quantity <= entry?.breakQty) || sortedTable[sortedTable.length - 1] || { breakQty: 0, unitPrice: 0, finalPrice: 0 };
  };


  const calculateSubTotal = () => {
    return cartData?.reduce((total, product) => {
      const { unitPrice = 0 } = getBreakQtyDetails(
        product.productDetails?.quantityTable,
        product.quantity
      ) || {};
      return total + product.quantity * unitPrice;
    }, 0);
  };

  const calculateTax18 = () => {
    const subtotal = calculateSubTotal() || 0;
    return subtotal * 0.18;
  };

  const calculateTotal = () => {
    const subtotal = calculateSubTotal() || 0;
    return subtotal + calculateTax18();
  };

  const placeOrder = async () => {
    const hasOutOfStockItem = cartData?.some(item => {
      const availQty = item.productDetails?.inventory?.qtyAvailable ?? 0;
      const isOutOfStock = item.productDetails?.status === 'OUT OF STOCK' || availQty <= 0;
      return isOutOfStock || item.quantity > availQty;
    });

    if (hasOutOfStockItem) {
      return toast.error('One or more products in your cart are out of stock or exceed available quantity.');
    }

    const datas = {
      products: selectedProducts,
      address: selectedAddress
    }
    setCheckoutLoading(true)
    try {

      const { data } = await api.placeOrder(datas)
      if (data) {

        toast.success('Order placed successfully')
        navigate('/')
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'unable to process your request please try again later')
    } finally {
      setCheckoutLoading(false)
    }

  };


  const [currentStep, setCurrentStep] = useState(2); // 2: Address, 3: Payment
  const [selectedPaymentMode, setSelectedPaymentMode] = useState('online');

  const handleContinueToPayment = () => {
    if (!selectedAddress) {
      return toast.error('Please select or add a delivery address');
    }
    setCurrentStep(3);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const [selectedItemIds, setSelectedItemIds] = useState([]);
  const [itemInputs, setItemInputs] = useState({});
  const [sortAscending, setSortAscending] = useState(null);

  useEffect(() => {
    if (cartData?.length > 0) {
      setSelectedItemIds(cartData.map((item) => item.productId));
      const initialInputs = {};
      cartData.forEach((item) => {
        initialInputs[item.productId] = {
          customerNo: item.customerNo || '',
          targetPrice: item.targetPrice || '',
          leadTime: item.leadTime || '',
        };
      });
      setItemInputs(initialInputs);
    }
  }, [cartData]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedItemIds(cartData?.map((item) => item.productId) || []);
    } else {
      setSelectedItemIds([]);
    }
  };

  const handleToggleSelectItem = (productId) => {
    setSelectedItemIds((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };

  const handleInputChange = (productId, field, value) => {
    setItemInputs((prev) => ({
      ...prev,
      [productId]: {
        ...(prev[productId] || {}),
        [field]: value,
      },
    }));
  };

  const handleQuantityChange = (productId, newQuantity) => {
    if (isNaN(newQuantity) || newQuantity < 1) return;
    const updatedProducts = cartData?.map((product) => {
      if (product.productId === productId) {
        return { ...product, quantity: newQuantity };
      }
      return product;
    });
    dispatch(setCartData(updatedProducts));
  };

  const toggleAvailabilitySort = () => {
    if (sortAscending === null) setSortAscending(true);
    else if (sortAscending === true) setSortAscending(false);
    else setSortAscending(null);
  };

  const getSortedCartData = () => {
    if (!cartData) return [];
    let items = [...cartData];
    if (sortAscending !== null) {
      items.sort((a, b) => {
        const availA = a?.productDetails?.inventory?.qtyAvailable ?? 0;
        const availB = b?.productDetails?.inventory?.qtyAvailable ?? 0;
        return sortAscending ? availA - availB : availB - availA;
      });
    }
    return items;
  };

  const sortedCartData = getSortedCartData();
  const displayProduct = showLess ? sortedCartData?.slice(0, 5) : sortedCartData;

  return (
    <>
      <div className={styles.stepperContainer}>
        <div className={styles.stepperWrapper}>
          <div className={`${styles.step} ${styles.completedStep}`} onClick={() => navigate('/cart')}>
            <div className={styles.stepCheckIcon}>✓</div>
            <span className={styles.stepText}>CART</span>
          </div>
          <div className={styles.stepDivider}></div>
          <div
            className={`${styles.step} ${currentStep === 2 ? styles.activeStep : currentStep > 2 ? styles.completedStep : ''}`}
            onClick={() => currentStep > 2 && setCurrentStep(2)}
          >
            {currentStep > 2 ? <div className={styles.stepCheckIcon}>✓</div> : null}
            <span className={styles.stepText}>ADDRESS</span>
          </div>
          <div className={styles.stepDivider}></div>
          <div className={`${styles.step} ${currentStep === 3 ? styles.activeStep : ''}`}>
            <span className={styles.stepText}>PAYMENT</span>
          </div>
        </div>
        <div className={styles.secureBadge}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#512DA8" strokeWidth="2.5">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
          <span>100% SECURE CHECKOUT</span>
        </div>
      </div>

      <div className={styles.checkoutContainer}>
        {currentStep === 2 ? (
          /* STEP 2: ADDRESS SELECTION */
          <div className={styles.summarySection}>
            <div className={styles.sectionHeaderRow}>
              <h3>Select Delivery Address</h3>
              <button
                className={styles.topAddBtn}
                onClick={() => { dispatch(setCustomerEditData({})); setAddShipPopupOpen(true); }}
              >
                + ADD NEW ADDRESS
              </button>
            </div>

            <div className={styles.addressSection}>
              {customer?.shippingAddress?.map((address, index) => (
                <div
                  key={index}
                  className={`${styles.address} ${selectedAddress === address ? styles.selectedAddress : ''}`}
                  onClick={() => setSelectedAddress(address)}
                >
                  <div className={styles.displayFlex}>
                    <input
                      type="radio"
                      id={`address-${index}`}
                      name="address"
                      value={index}
                      checked={selectedAddress === address}
                      onChange={() => setSelectedAddress(address)}
                    />
                    <div>
                      <p>{customer?.name || 'Customer Address'} <span>HOME</span></p>
                      <p>{address?.streetAddress} , {address?.state}, {address?.country} - {address?.zipCode}</p>
                      <p>Mobile: <strong>{customer?.phone}</strong></p>
                      <p>Email: {customer?.email}</p>
                      <div className={styles.addressActions}>
                        <button
                          className={styles.actionOutlineBtn}
                          onClick={(e) => { e.stopPropagation(); handleEditClick(address); }}
                        >
                          EDIT
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <div className={styles.addressDivider} onClick={() => { dispatch(setCustomerEditData({})); setAddShipPopupOpen(true); }}>
                <span>+ Add New Address</span>
              </div>

              {isAddShipPopupOpen && <AddBilling
                onClose={() => setAddShipPopupOpen(false)}
                heading={'Add New Shipping Address'}
                from="csa"
                parent="shipping"
              />
              }

              {isEditShipPopupOpen &&
                <AddBilling
                  onClose={() => setEditShipPopupOpen(false)}
                  heading={'Edit Billing Address'}
                  from="cbe"
                  parent="shipping"
                />
              }
            </div>

            <div style={{ marginTop: 32 }}>
              <div className={styles.sectionHeaderRow}>
                <h3>Order Items Summary ({cartData?.length || 0})</h3>
              </div>

              {/* B2B CATALOG TABLE VIEW */}
              <div className={styles.b2bTableContainer}>
                <div className={styles.b2bTableHeader}>
                  <div className={styles.colIndexHeader}>#</div>
                  <div className={styles.colDetailsHeader}>Product Details</div>
                  <div className={styles.colQtyHeader}>Quantity</div>
                  <div className={styles.colUnitPriceHeader}>Unit Price</div>
                  <div className={styles.colExtPriceHeader}>Extended Price</div>
                </div>

                <div className={styles.b2bTableBody}>
                  {displayProduct?.map((data, idx) => {
                    const productDetails = data?.productDetails || {};
                    const overview = productDetails?.productOverview || {};
                    const sku = productDetails?.sku || productDetails?.catalogNumber || productDetails?._id?.substring(0, 9)?.toUpperCase() || `C${52191718 + idx}`;
                    const partNo = overview?.productNumber?.[0] || productDetails?.mpn || '6ES7972-0DA00-0AA0';
                    const brand = overview?.manufacturer?.[0]?.name || productDetails?.brand || 'SIEMENS';
                    const category = overview?.categories?.[0] || productDetails?.category || 'Box Accessories';
                    const availQty = productDetails?.inventory?.qtyAvailable ?? 0;
                    const isOutOfStock = productDetails?.status === 'OUT OF STOCK' || availQty <= 0;

                    const { unitPrice = 0 } = getBreakQtyDetails(
                      productDetails?.quantityTable,
                      data?.quantity
                    ) || {};

                    const formattedUnitPrice = (unitPrice).toFixed(4);
                    const extendedPrice = (unitPrice * data?.quantity).toFixed(2);
                    const productParam = overview?.productNumber?.[0] || productDetails?._id || sku;
                    const productUrl = `/productCode/${encodeURIComponent(productParam)}`;

                    return (
                      <div key={data?.productId || idx} className={styles.b2bTableRow}>
                        {/* Column 1: Index Number */}
                        <div className={styles.colIndexNum}>{idx + 1}</div>

                        {/* Column 2: Product Image & Details */}
                        <div className={styles.colProductDetails}>
                          <a
                            href={productUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.productImgWrap}
                          >
                            {productDetails?.assets?.featuredImage?.[0] ? (
                              <img src={productDetails?.assets?.featuredImage[0]} alt={partNo} />
                            ) : (
                              <div className={styles.placeholderImg}>📦</div>
                            )}
                          </a>
                          <div className={styles.productInfoWrapper}>
                            <a
                              href={productUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.partNoText}
                            >
                              {partNo}
                            </a>
                            <div className={styles.brandNameText}>{brand}</div>
                          </div>
                        </div>

                        {/* Quantity Column */}
                        <div className={styles.colQuantity}>
                          <input
                            type="number"
                            min="1"
                            value={data?.quantity || 1}
                            onChange={(e) => handleQuantityChange(data?.productId, parseInt(e.target.value, 10) || 1)}
                            className={styles.qtyBoxInput}
                          />
                          <div className={styles.stockStatusSubtext}>
                            {availQty} In Stock
                          </div>
                        </div>

                        {/* Unit Price Column */}
                        <div className={styles.colUnitPrice}>
                          <span>₹{formattedUnitPrice}</span>
                        </div>

                        {/* Extended Price Column */}
                        <div className={styles.colExtendedPrice}>
                          <span>₹{extendedPrice}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {sortedCartData?.length > 5 && (
                <div className={styles.productMore} onClick={() => setShowLess(!showLess)}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: '#512DA8' }}>
                    {showLess ? `+ Show ${sortedCartData.length - 5} More Items` : '- Show Less Items'}
                  </span>
                </div>
              )}
            </div>
          </div>
        ) : (
          /* STEP 3: PAYMENT METHOD SELECTION */
          <div className={styles.summarySection}>
            <div className={styles.sectionHeaderRow}>
              <h3>Choose Payment Mode</h3>
            </div>
            <div className={styles.paymentOptionsContainer}>
              <div
                className={`${styles.paymentOptionCard} ${selectedPaymentMode === 'online' ? styles.selectedPaymentOption : ''}`}
                onClick={() => setSelectedPaymentMode('online')}
              >
                <div className={styles.paymentOptionLeft}>
                  <input
                    type="radio"
                    name="paymentMode"
                    checked={selectedPaymentMode === 'online'}
                    onChange={() => setSelectedPaymentMode('online')}
                  />
                  <div className={styles.paymentIconBadge}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
                      <line x1="1" y1="10" x2="23" y2="10"/>
                    </svg>
                  </div>
                  <div className={styles.paymentOptionDetails}>
                    <span className={styles.paymentOptionTitle}>Online Payment / UPI / Cards</span>
                    <span className={styles.paymentOptionSub}>Instant checkout via Net Banking, Credit/Debit Cards, or UPI</span>
                  </div>
                </div>
                <span className={`${styles.paymentTag} ${selectedPaymentMode === 'online' ? styles.paymentTagActive : ''}`}>
                  INSTANT
                </span>
              </div>

              {customer?.status === 'APPROVED' && (
                <div
                  className={`${styles.paymentOptionCard} ${selectedPaymentMode === 'po' ? styles.selectedPaymentOption : ''}`}
                  onClick={() => setSelectedPaymentMode('po')}
                >
                  <div className={styles.paymentOptionLeft}>
                    <input
                      type="radio"
                      name="paymentMode"
                      checked={selectedPaymentMode === 'po'}
                      onChange={() => setSelectedPaymentMode('po')}
                    />
                    <div className={styles.paymentIconBadge}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                        <polyline points="14 2 14 8 20 8"/>
                        <line x1="16" y1="13" x2="8" y2="13"/>
                        <line x1="16" y1="17" x2="8" y2="17"/>
                      </svg>
                    </div>
                    <div className={styles.paymentOptionDetails}>
                      <span className={styles.paymentOptionTitle}>
                        Credit Terms
                      </span>
                      <span className={styles.paymentOptionSub}>
                        {customer?.creditTerms === 'ADVANCE' && '100% Advance Payment'}
                        {customer?.creditTerms === '15_DAYS' && 'Net 15 Days'}
                        {customer?.creditTerms === '30_DAYS' && 'Net 30 Days'}
                        {customer?.creditTerms === '45_DAYS' && 'Net 45 Days'}
                        {customer?.creditTerms === '60_DAYS' && 'Net 60 Days'}
                        {customer?.creditTerms === '90_DAYS' && 'Net 90 Days'}
                        {!['ADVANCE', '15_DAYS', '30_DAYS', '45_DAYS', '60_DAYS', '90_DAYS'].includes(customer?.creditTerms) && (customer?.creditTerms || 'Invoice billing with standard corporate payment terms')}
                      </span>
                    </div>
                  </div>
                  <span className={`${styles.paymentTag} ${selectedPaymentMode === 'po' ? styles.paymentTagActive : ''}`}>
                    APPROVED B2B
                  </span>
                </div>
              )}
            </div>
          </div>
        )}

        {/* RIGHT SIDEBAR ORDER SUMMARY */}
        <div className={styles.paymentSection}>
          <div className={styles.deliveryEstimateBox}>
            <div className={styles.truckIconBox}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6C38F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="1" y="3" width="15" height="13" rx="2"/>
                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
                <circle cx="5.5" cy="18.5" r="2.5"/>
                <circle cx="18.5" cy="18.5" r="2.5"/>
              </svg>
            </div>
            <div className={styles.deliveryText}>
              <span>Estimated Delivery: <strong>2 - 4 Business Days</strong></span>
            </div>
          </div>

          <div className={styles.paymentSummary}>
            <h3 style={{ fontSize: 13, textTransform: 'uppercase', letterSpacing: 0.8, color: '#64748B', marginBottom: 16 }}>PRICE DETAILS ({cartData?.length || 0} Items)</h3>
            <div className={styles.paymentItem}>
              <span>Total Subtotal</span>
              <strong>₹{calculateSubTotal()?.toFixed(2)}</strong>
            </div>
            <div className={styles.paymentItem}>
              <span>Tax</span>
              <strong>₹{calculateTax18()?.toFixed(2)}</strong>
            </div>
            <div className={styles.paymentItem}>
              <span>Shipping & Handling</span>
              <strong style={{ color: '#10B981' }}>FREE</strong>
            </div>
            <div className={styles.paymentItem}>
              <strong>Total Amount</strong>
              <strong>₹{calculateTotal()?.toFixed(2)}</strong>
            </div>
          </div>

          <div className={styles.buttons}>
            {currentStep === 2 ? (
              <>
                <button className={styles.confirmButton} onClick={handleContinueToPayment}>
                  CONTINUE TO PAYMENT →
                </button>
                <button className={styles.backButton} onClick={() => navigate('/cart')}>Back to Cart</button>
              </>
            ) : (
              <>
                <button className={styles.confirmButton} onClick={placeOrder} disabled={checkoutLoading}>
                  {checkoutLoading ? 'Processing...' : 'CONFIRM & PLACE ORDER'}
                </button>
                <button className={styles.backButton} onClick={() => setCurrentStep(2)}>Back to Address</button>
              </>
            )}
          </div>

          <div className={styles.trustFooter}>
            <div className={styles.trustIcons}>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                256-Bit SSL
              </span>
              <span>•</span>
              <span>Visa</span>
              <span>•</span>
              <span>MasterCard</span>
              <span>•</span>
              <span>UPI</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Checkout;
